/* realSessionStorage.js */

const DEFAULT_TTL = 30 * 60 * 1000; 
const HEARTBEAT_INTERVAL = 30 * 1000;
const TAB_TIMEOUT = HEARTBEAT_INTERVAL * 2.5; // Marge de sécurité

const TABS_KEY = '__rss_tabs__'; // Stockera { id: lastActive }
const LAST_SEEN_KEY = '__rss_last_seen__';
const STORE_KEY = '__rss_store__';

let TAB_ID = sessionStorage.getItem('__rss_tab_id__');
if (!TAB_ID) {
    TAB_ID = crypto.randomUUID();
    sessionStorage.setItem('__rss_tab_id__', TAB_ID);
}

let heartbeatTimer = null;

const now = () => Date.now();

function read(key, fallback) {
    try {
        const item = localStorage.getItem(key);
        return item !== null ? JSON.parse(item) : fallback;
    } catch (e) { return fallback; }
}

function write(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

/**
 * Nettoie les onglets fantômes et vérifie si la session globale est morte
 */
function syncTabsAndSession(ttl) {
    const currentTime = now();
    const lastSeen = Number(localStorage.getItem(LAST_SEEN_KEY) || 0);
    
    // 1. Si silence radio total depuis trop longtemps -> Reset complet
    if (currentTime - lastSeen > ttl) {
        localStorage.removeItem(STORE_KEY);
        localStorage.removeItem(TABS_KEY);
        localStorage.setItem(LAST_SEEN_KEY, currentTime.toString());
        return { [TAB_ID]: currentTime };
    }

    // 2. Récupérer les onglets actifs { id: timestamp }
    let tabs = read(TABS_KEY, {});

    // 3. Filtrer les onglets qui n'ont pas envoyé de heartbeat récemment
    const activeTabs = {};
    Object.keys(tabs).forEach(id => {
        if (currentTime - tabs[id] < TAB_TIMEOUT || id === TAB_ID) {
            activeTabs[id] = tabs[id];
        }
    });

    // 4. Mettre à jour l'onglet courant
    activeTabs[TAB_ID] = currentTime;
    
    localStorage.setItem(LAST_SEEN_KEY, currentTime.toString());
    write(TABS_KEY, activeTabs);
    
    return activeTabs;
}

function startHeartbeat() {
    if (heartbeatTimer) return;
    heartbeatTimer = setInterval(() => {
        // On ne met à jour que si l'onglet est actif pour éviter de maintenir 
        // une session indéfiniment sur un PC laissé allumé avec l'onglet en fond
        if (!document.hidden) {
            syncTabsAndSession(DEFAULT_TTL);
        }
    }, HEARTBEAT_INTERVAL);
}

const realSessionStorage = {
    getItem(key, options = {}) {
        const ttl = options.ttl || DEFAULT_TTL;
        syncTabsAndSession(ttl);
        startHeartbeat();

        const store = read(STORE_KEY, {});
        return store[key] !== undefined ? store[key] : null;
    },

    setItem(key, value) {
        syncTabsAndSession(DEFAULT_TTL);
        startHeartbeat();

        const store = read(STORE_KEY, {});
        store[key] = String(value);
        write(STORE_KEY, store);
    },

    removeItem(key) {
        const store = read(STORE_KEY, {});
        delete store[key];
        write(STORE_KEY, store);
    },

    clear() {
        localStorage.removeItem(STORE_KEY);
        localStorage.removeItem(TABS_KEY);
        localStorage.removeItem(LAST_SEEN_KEY);
    }
};

module.exports = realSessionStorage;